import React, { useEffect, useState } from 'react';
import Chart from 'react-apexcharts';
import moment from 'moment/moment';
import { useDispatch } from 'react-redux';
import AnalyticsChartWrapper from './AnalyticsChartWrapper';
import classes from '../analytics.module.scss';
import { useQuery } from '../../../../../utils/hooks/useQuery';
import { getPipelineProgressRequest } from '../../../../../store/actions/possiblePersons';
import Loader from '../../../../_common/Loader/Loader';

const chartTemplate = {
  series: [],

  options: {
    chart: {
      height: 390,
      type: 'bar',
      stacked: true,
      toolbar: {
        show: false,
      },
    },
    grid: {
      strokeDashArray: 5,
      colors: '#E5E5EF',
    },
    legend: {
      show: true,
      position: 'bottom',
      horizontalAlign: 'left',
      offsetX: 30,
    },
    plotOptions: {
      bar: {
        borderRadiusApplication: 'end',
        borderRadiusWhenStacked: 'last',
        borderRadius: 5,
        dataLabels: {
          position: 'top',
          colors: {
            backgroundBarColors: ['#F8F8FF'],
          },
        },
        columnWidth: '45%',
      },
    },
    fill: {
      colors: ['#4A3AFF', '#FFEB3A', '#7FE47E'],
    },
    dataLabels: {
      enabled: false,
    },
    xaxis: {
      categories: [],
      position: 'bottom',
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
      crosshairs: {
        show: false,
      },
      tooltip: {
        enabled: false,
      },
      labels: {
        style: {
          fontStyle: 'normal',
          fontWeight: 300,
          fontSize: '14px',
          lineHeight: '16px',
          textAlign: 'center',
          letterSpacing: '0.06em',
          textTransform: 'uppercase',
          colors: '#615E83',
        },
      },
    },
    yaxis: {
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
      labels: {
        show: true,
        style: {
          fontStyle: 'normal',
          fontWeight: 400,
          fontSize: '14px',
          lineHeight: '16px',
          textAlign: 'center',
          letterSpacing: '0.06em',
          textTransform: 'uppercase',
          colors: '#615E83',
        },
      },
    },
  },

};

const thisMonthStartDay = moment().startOf('month').format('YYYY-MM-DD');
const thisMonthEndDate = moment().format('YYYY-MM-DD');

const PipelineProgress = () => {
  const { query, setQuery } = useQuery();

  const {
    pipelineId, pipelineName, pipelineStart, pipelineEnd,
  } = query;

  const dispatch = useDispatch();
  const [chart, setChart] = useState(chartTemplate);
  const [loading, setLoading] = useState(false);
  const [requestData, setRequestData] = useState({
    start: pipelineStart || thisMonthStartDay,
    end: !pipelineStart ? thisMonthEndDate : (pipelineEnd || ''),
    healthPlanId: pipelineId || '',
    healthPlanName: pipelineName || '',
  });

  const {
    start, end, healthPlanId, healthPlanName,
  } = requestData;

  const [healthValue, setHealthValue] = useState(pipelineName || '');

  useEffect(() => {
    (async () => {
      setLoading(true);
      const { payload: { data: { data } } } = await dispatch(getPipelineProgressRequest(requestData));

      setChart((prev) => ({
        series: [
          {
            name: 'Contacting',
            data: data.map((d) => d.contacting),
          },
          {
            name: 'Followed',
            data: data.map((d) => d.followed),
          },
          {
            name: 'Received',
            data: data.map((d) => d.received),
          },
        ],
        options: {
          ...prev.options,
          xaxis: {
            ...prev.options.xaxis,
            categories: data.map((d) => d.date),
          },
        },
      }));

      setQuery({
        ...query, pipelineStart: start, pipelineEnd: end, pipelineId: healthPlanId, pipelineName: healthPlanName,
      });
      setLoading(false);
    })();
  }, [requestData]);

  const changeDateAndHealth = (value, path, planName) => {
    setRequestData((prev) => {
      if (path === 'date') {
        return {
          ...prev,
          start: value[0],
          end: value[1],
        };
      }
      return {
        ...prev,
        [path]: value,
        healthPlanName: planName,
      };
    });
  };

  return (
    <AnalyticsChartWrapper
      chartWrapperClass="chart_wrapper_follow_up"
      title="Pipeline Progress"
      date={requestData}
      healthValue={healthValue}
      setHealthValue={setHealthValue}
      onChange={changeDateAndHealth}
      className={classes.bottom_chart}
    >
      {loading
        ? <div className={classes.loader_wrapper}><Loader /></div>
        : !chart.options.xaxis.categories.length && !loading
          ? <div className={classes.notResult}>No Data Found</div>
          : (
            <Chart
              options={chart.options}
              series={chart.series}
              type="bar"
              height={350}
              width="100%"
            />
          )}
    </AnalyticsChartWrapper>
  );
};

export default PipelineProgress;
